import {useAuth} from "../contexts/AuthContext";
import Login from "./Login";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const {user} = useAuth();

    return <>{user ? children : <Login />}</>
}